import "./HotelSeoDigitalMarketing.module.css";
import Header from "@/reusable_sections/Header";
import Consultation from "./sections/Consultation";
import Services from "./sections/Services";
import Faq from "./sections/Faq";
import Performance from "./sections/Performance";
import Expertise from "./sections/Expertise";
import Footer from "@/reusable_sections/Footer";
export default function HotelSeoDigitalMarketingPage() {
  return <div>
      <Header />
      <Consultation />
      <Services />
      <Faq />
      <Performance />
      <Expertise />
      <Footer />
    </div>;
}